import IStore from '../_types';

const state: IStore = {
  all: [],
};

export default state;
